import { render, staticRenderFns } from "./DisableConfirmation.vue?vue&type=template&id=82cff1b2&"
import script from "./DisableConfirmation.vue?vue&type=script&lang=js&"
export * from "./DisableConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports